module.exports = __webpack_public_path__ + "img/zp3.eeffde92.png";